module.exports = __webpack_public_path__ + "static/media/CrystalPlate.14354207.wav";